import {Button, Dialog, DialogTitle, DialogContent, DialogActions, Typography, IconButton, Stack} from '@mui/material';
import {Close} from '@carbon/icons-react';

export interface PopUpProps {
  title: string;
  children: React.ReactNode;
  open?: boolean;
  maxWidth?: 'xs' | 'sm';
  cancelText?: string | undefined;
  confirmText?: string | undefined;
  onConfirm: () => void;
  onCancel?: () => void;
  confirmedDisabled?: boolean;
  width?: string;
}

const PopUp = ({
  title,
  children,
  open = true,
  cancelText = 'Cancel',
  confirmText = 'Confirm',
  onConfirm,
  onCancel,
  maxWidth = 'xs',
  confirmedDisabled = false,
  width = '100%',
}: PopUpProps) => {
  return (
    <Dialog
      open={open}
      onClose={() => {
        onCancel && onCancel();
      }}
      aria-labelledby='popup-dialog'
      fullWidth
      maxWidth={maxWidth}
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: 'rgba(0, 0, 0, 0.25)', // Change backdrop color and opacity
          },
        },
      }}
      PaperProps={{
        sx: {
          backgroundColor: 'grey.200',
          boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.25)',
        },
      }}
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: width, // Set your width here
          },
        },
      }}
    >
      <DialogTitle sx={{p: '20px'}} variant='h1' id='confirm-dialog'>
        <Stack direction='row' justifyContent='space-between' alignItems='flex-start'>
          <Typography variant='h1' fontSize='24px' color='grey.800'>
            {title}
          </Typography>
          <IconButton
            sx={{p: 0}}
            disableRipple
            onClick={() => {
              if (onCancel) {
                onCancel();
              } else {
                onConfirm();
              }
            }}
          >
            <Close height='22px' width='22px' color='black' />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent sx={{px: '20px'}}>{children}</DialogContent>
      <DialogActions sx={{justifyContent: 'flex-end', p: '20px'}}>
        {onCancel && (
          <Button
            variant='text'
            size='small'
            onClick={() => {
              onCancel && onCancel();
            }}
            color='primary'
            sx={{px: 0}}
          >
            {cancelText}
          </Button>
        )}
        <Button
          disabled={confirmedDisabled}
          variant='contained'
          size='small'
          onClick={() => {
            onConfirm();
          }}
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PopUp;
